module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-card-incard"
  }, [_c('div', {
    staticClass: "m-card-incard-header"
  }, [_c('span', {
    staticClass: "fz15"
  }, [_vm._v("@" + _vm._s(_vm.data.UserName))]), _vm._v(" "), (_vm.data.UserName === (_vm.data.TopicUserName || _vm.PrensenterName)) ? _c('span', {
    staticClass: "fz11 m-avatar-name--host"
  }, [_vm._v("主持人")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "m-card-incard-time fz12"
  }, [_vm._v(_vm._s(_vm.data.CreateTime))])]), _vm._v(" "), _c('div', {
    staticClass: "m-card-incard-body"
  }, [_c('p', {
    staticClass: "fz15",
    domProps: {
      "innerHTML": _vm._s(_vm.commentContent)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-66ce2cac"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/card/incard.vue
// module id = 208
// module chunks = 1